import { render, staticRenderFns } from "./ImageArray2.vue?vue&type=template&id=15216edc&scoped=true"
import script from "./ImageArray2.vue?vue&type=script&lang=js"
export * from "./ImageArray2.vue?vue&type=script&lang=js"
import style0 from "./ImageArray2.vue?vue&type=style&index=0&id=15216edc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15216edc",
  null
  
)

export default component.exports